import { render, staticRenderFns } from "./aboutend.vue?vue&type=template&id=80f88d0a&"
import script from "./aboutend.vue?vue&type=script&lang=js&"
export * from "./aboutend.vue?vue&type=script&lang=js&"
import style0 from "./aboutend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports